<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active toUpper" aria-current="page">{{$t('report_sale_invoice_by_item')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-print"></i> {{$t('print')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                            <tr class="toUpper">
                                <th class="text-center">{{$t('no')}}</th>
                                <th>{{$t('date')}}</th>
                                <th>{{$t('invoice_no') }}</th>
                                <th>{{$t('item_code')}}</th>
                                <th>{{$t('item_name')}}</th>
                                <th class="text-right">{{$t('qty')}}</th>
                                <th>{{$t('uom')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td>{{$format(ret.Date,'DD/MM/YYYY')}}</td>
                                <td>{{ret.InvoiceNum}}</td>
                                <td>{{ret.ItemCode}}</td>
                                <td>{{ret.ItemName}}</td>
                                <td class="text-right">{{ret.Quantity}}</td>
                                <td>{{ret.UomName}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="5" class="text-right">Total Quantity</th>
                                <th class="text-right">{{totlaQty}}</th>
                                <th></th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                records: []
            }
        },
        created() {
            this.toList();
        },
        methods: {
            toList() {
                var loading = this.$loading.show();
                var req = {
                    ItemId: this.$route.params.id,
                    CompanyId: this.$store.state.company.Id
                };
                this.$api().post("report/sale-invoice-detail-item", req).then(res => {
                    if (this.$isValid(res)) {
                        this.records = res.data.Json.Lines;
                    }
                }).finally(() => { loading.hide(); });
            }
        },
        computed: {
            totlaQty() {
                let total = 0;
                this.records.map(el => {
                    total += el.Quantity;
                });
                return total;
            }
        }
    }
</script>